/** Iter 54 — single source of truth for the global navigation (desktop inline + mobile menu). */

export const NAV_ITEMS = [
  { key: "hub", to: "/hub", label: "Agent Hub" },
  { key: "workspaces", to: "/workspaces", label: "Workspaces" },
  { key: "findings", to: "/findings", label: "Findings" },
  { key: "deliverables", to: "/deliverables", label: "Deliverables" },
  { key: "framework", to: "/framework", label: "Framework" },
];

export const GUEST_NAV_ITEMS = [{ key: "framework", to: "/framework", label: "Framework" }];

/** Items for the current auth state; `undefined` user = auth still loading → nothing. */
export function navItemsFor(user) {
  if (user === undefined) return [];
  return user ? NAV_ITEMS : GUEST_NAV_ITEMS;
}

/** Tailwind breakpoint below which the navigation collapses into the menu (≥ lg shows the inline nav). */
export const NAV_COLLAPSE_BREAKPOINT_PX = 1024;
